import { render, staticRenderFns } from "./ExternalSystemList.vue?vue&type=template&id=64355b1e&scoped=true&"
import script from "./ExternalSystemList.vue?vue&type=script&lang=ts&"
export * from "./ExternalSystemList.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalSystemList.vue?vue&type=style&index=0&id=64355b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64355b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VDivider,VHover,VRow,VSpacer,VTextField})
